import React, { useEffect, useState } from 'react'
import { Box, Dialog, DialogContent, Tooltip } from '@mui/material'
import SelectInput from '../../Common/ui/selectInput'
import * as ComplianceApi from '../../API/ComplianceAPI'
import Loading from 'src/Common/ui/Loading'
import Textarea from 'src/Common/ui/textArea'
import { useForm } from 'react-hook-form'
import { cn } from 'src/lib/utils'
import { STATUS_ENUMS } from 'src/Entities/StatusEnums'
import { Button } from 'src/Common/ui/button'
import { t } from 'i18next'
import Input from 'src/Common/ui/input'
import { toaster } from 'src/Common/ui/Toaster'
import { typePreviewTransferCondition } from 'src/Entities/TransferEntities'

function TcModal ({ isOpen, handleClose, type, getCompliancePreview, setSelectAll, raciMatrixOption, userData, compliancePreview }) {
    // const [ getData, setGetData ] = useState([])
    const [ loading, setLoading ] = useState(false)
    // const [ raciMatrixOptions, setRacimatrixOptions ] = useState()
    const { formState: { errors, isSubmitting, isLoading }, register, reset, control, handleSubmit, setValue } = useForm({ mode: 'onChange' })

    const [ departments, setDepartments ] = useState([])
    const [ users, setUsers ] = useState([])
    const [ user, setUser ] = useState(null)
    const [ selectedRole, setSelectedRole ] = useState(null)
    const [ selectedDepartment, setSelectedDepartment ] = useState(null)
    // eslint-disable-next-line no-unused-vars
    const [ remarks, setRemarks ] = useState('')
    const queryParams = new URLSearchParams(location.search)

    const matrixParam = +queryParams.get('matrix')

    // Get Org ID from LocalStorage
    const orgId = localStorage.getItem('orgId')
    const loginId = localStorage.getItem('userId')
    // useEffect(() => {
    //     setGetData(compliancePreview)
    // }, [userData])
    useEffect(() => {
        if (isOpen) {
            setRemarks('')
            setValue('transfer', '')
        }
    }, [isOpen])

    useEffect(() => {
        if (userData?.roleId) {
            setValue('role', userData.roleId)
            handleRoleChange(userData.roleId)
            handleDepartmentChange(userData.departmentId)
        }
    }, [userData])

    const handleRoleChange = async (roleId) => {
        setSelectedRole(roleId)
        setDepartments([])
        setUsers([])

        setLoading(true)
        try {
            const { data } = await ComplianceApi.GetAllDepartmentByRole(roleId, orgId)
            setDepartments(data || [])
        } catch (error) {
            console.error('Error fetching departments:', error)
        }
        setLoading(false)
    }

    const handleDepartmentChange = async (deptId) => {
        setSelectedDepartment(deptId)
        setUsers([])
        setLoading(true)
        try {
            const { data } = await ComplianceApi.GetAllUserByRole(selectedRole, orgId, deptId)
            setUsers(data.filter(ele => ele.userId !== userData.userId) || []) // Populate users dropdown
        } catch (error) {
            console.error('Error fetching users:', error)
        }
        setLoading(false)
    }

    const handleUserChange = (user) => {
        setUser(user)
    }
    const onInputChange = (e) => {
        setRemarks(e)
    }
    function convertISTtoUTC (istDateString) {
        const date = new Date(istDateString)
        const offset = 5.5 * 60 * 60 * 1000 // IST offset in milliseconds (+5:30)
        const utcTime = new Date(date.getTime() - offset)
        return utcTime.toISOString() // Converts to UTC ISO format
    }
    const handleApply = async () => {
        let matrixRequest
        setLoading(true)
        if (typePreviewTransferCondition(type)) {
            matrixRequest = compliancePreview.filter(ele => ele.checkbox).map(item => {
                const find = item.raciiMatrices.find(ele => ele.raciId === +matrixParam)
                return {
                    raciId: find.raciId,
                    organizationId: +orgId,
                    orgRegulationId: find.id,
                    regulationId: item.regulationId,
                    departmentId: selectedDepartment,
                    userId: +user,
                    roleId: userData.roleId

                }
            })
        } else {
            matrixRequest = compliancePreview.filter(ele => ele.checkbox).map(item => {
                return {
                    raciId: item.raciId,
                    organizationId: +orgId,
                    orgRegulationId: item.complianceId,
                    regulationId: item.regulationId,
                    departmentId: selectedDepartment,
                    userId: +user,
                    roleId: userData.roleId

                }
            })
        }
        const finalData = {
            id: 0,
            matrixRequest,
            fromUser: userData.userId,
            toUser: user,
            comments: remarks,
            createdAt: convertISTtoUTC(new Date()),
            createdBy: +loginId,
            modifiedBy: +loginId,
            modifiedAt: convertISTtoUTC(new Date()),
            status: STATUS_ENUMS.Active
        }
        try {
            handleClose()
            const response = typePreviewTransferCondition(type) ? await ComplianceApi.TransferBody(orgId, loginId, finalData) : await ComplianceApi.TransferCompliance(orgId, loginId, finalData)
            toaster('success', `${response.data.map((ele, i) => `${ele}`)} ${typePreviewTransferCondition(type) ? 'Body' : 'Compliance'} has been Transferred Successfully`)
            setLoading(false)
            setSelectAll(false)
            onInputChange('')
            reset({})
            setUser(null)
            setSelectedDepartment(null)
            getCompliancePreview()
        } catch (error) {
            setLoading(false)

            toaster('error', <p>{`Error in transferring  ${typePreviewTransferCondition(type) ? 'Body' : 'Compliance'}`}</p>)
        }
    }
    const handleCancel = () => {
        reset({})
        setUser(null)
        setSelectedDepartment(null)
        handleClose()
        setRemarks('')
    }
    return (
        <>
            <Loading isLoading={loading} />

            <Dialog
                open = {isOpen}
                onClose={handleCancel}
                maxWidth="sm"
                fullWidth
                PaperProps={{ sx: { overflowX: 'hidden', zIndex: 1300 } }}
            >
                <DialogContent sx={{ padding: 0 }}>
                    <div className='h-12 bg-primary flex items-center p-[0.8rem]'>
                        <div style={{ color: '#fff' }} className='flex-grow text-center text-white font-semibold'>{typePreviewTransferCondition(type) ? 'Reassign Regulation' : 'Reassign Compliance'}</div>
                        <Tooltip title="Close" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <div className='cursor-pointer'><img src='/Common/Icon/CloseDialogX.svg' onClick={handleClose} /></div>
                        </Tooltip>
                    </div>
                    <div className="flex flex-col p-6 gap-4">
                        <div className="gap-4 w-full grid grid-cols-3">
                            {/* Role Field */}
                            <div>

                                {/* <SelectInput
                                    placeholder="Select Role"
                                    name="role"
                                    control={control}
                                    label='Role'
                                    required
                                    errors={errors}
                                    register={register}
                                    rules={{ required: 'Role is required' }}
                                    options={[{ value: userData.roleId, label: userData.roleName }]}
                                    value={selectedRole}
                                    onValueChange={handleRoleChange}
                                /> */}
                                <Input
                                    errors={errors}
                                    control={control}
                                    required
                                    rules={{ required: 'This field is required' }}
                                    placeholder="Select Role"
                                    name="role"
                                    register={register}
                                    label = 'Role'
                                    type="text"
                                    value={userData?.roleName}
                                    className='pointer-events-none bg-popover'
                                />
                            </div>
                            {/* Department Field */}
                            <div>

                                <SelectInput
                                    placeholder="Select Department"
                                    name="department"
                                    label='Department'
                                    control={control}
                                    required
                                    errors={errors}
                                    rules={{ required: 'Department is required' }}
                                    options={departments.map((dept) => ({ value: dept.id, label: dept.name }))}
                                    value={selectedDepartment}
                                    onValueChange={handleDepartmentChange}
                                    readOnly={!selectedRole}
                                />

                            </div>
                            <div>
                                {/* User Field */}
                                <SelectInput
                                    placeholder="Select User"
                                    name="user"
                                    label='User'
                                    control={control}
                                    required
                                    errors={errors}
                                    rules={{ required: 'User is required' }}
                                    options={users.map((user) => ({ value: user.id, label: user.name }))}
                                    value={user}
                                    onValueChange={handleUserChange}
                                    readOnly={!selectedDepartment && selectedRole}
                                />
                            </div>
                        </div>

                        {/* Remarks Field */}
                        <div>
                            <Textarea className={cn('ml-[0px]')} label="Remarks" value={remarks}
                                onValueChange={(e) => onInputChange(e)}
                                required
                                rules={{
                                    validate: (value) => {
                                        if (!value) return t('This field is required')
                                        if (value.length > 251) return t('Character count should not exceed 250')
                                        return true
                                    }
                                }}
                                defaultValue={remarks} type="text" placeholder="Enter Remarks" name="transfer" errors={errors} control={control} maxLength={250}/>
                        </div>
                        {/* Action Buttons */}
                        <div className=''>
                            <div className="flex justify-end space-x-4">
                                <Box>
                                    <Button onClick={() => handleCancel()}
                                        variant='outline'
                                        style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                                        disabled={loading}
                                    >
                         Cancel
                                    </Button>
                                </Box>
                                <Box>
                                    <Button onClick={handleSubmit(handleApply)} disabled={isSubmitting || isLoading || loading}
                                    >
                         Apply
                                    </Button>
                                </Box>
                            </div>
                        </div>
                    </div>

                </DialogContent>
            </Dialog>
        </>
    )
}

export default TcModal
